<template>
    <svg width="1.1em" height="1.1em" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="0.75" y1="1.5" x2="0.75" y2="10.5" stroke="white" stroke-linecap="round" />
        <path
            d="M12.25 5.13393C12.9167 5.51883 12.9167 6.48108 12.25 6.86598L4.75 11.1961C4.08333 11.581 3.25 11.0999 3.25 10.3301L3.25 1.66983C3.25 0.900026 4.08333 0.418901 4.75 0.803801L12.25 5.13393Z"
            fill="#F9F9F9" />
    </svg>

</template>